(function () {
  function initNewsletter(shell) {
    if (!shell || shell.dataset.newsletterReady === 'true') return;

    var form = shell.querySelector('.koota-home-newsletter__form');
    var input = form && form.querySelector('input[type="email"]');
    var field = form && form.querySelector('[data-koota-newsletter-field]');
    var status = form && form.querySelector('[data-koota-newsletter-status]');
    var submit = form && form.querySelector('button[type="submit"]');

    shell.dataset.newsletterReady = 'true';
    if (!form || !input || !field || !status) return;

    function update() {
      var value = input.value.trim();
      var hasValue = value.length > 0;
      var isValid = hasValue && input.validity.valid;
      var progress = Math.min(92, Math.round((value.length / 24) * 100));

      if (isValid) progress = 100;
      form.style.setProperty('--newsletter-progress', progress);
      form.classList.toggle('has-value', hasValue);
      form.classList.toggle('is-valid', isValid);
      field.classList.toggle('is-valid', isValid);

      if (isValid) status.textContent = 'Adresse prête à partir';
      else if (hasValue) status.textContent = 'La lettre se prépare…';
      else if (document.activeElement === input) status.textContent = 'À vous de jouer';
      else status.textContent = 'Votre lettre est prête';
    }

    input.addEventListener('focus', function () {
      form.classList.add('is-focused');
      update();
    });

    input.addEventListener('blur', function () {
      form.classList.remove('is-focused');
      update();
    });

    input.addEventListener('input', update);

    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      form.classList.add('is-submitting');
      status.textContent = 'Votre lettre s’envole…';
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
      }
    });

    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-koota-newsletter-shell]').forEach(initNewsletter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
